import Button, { Props as ButtonProps } from "@storeblocks/button";
import React from "react";
import { IconWrapper } from "./styled";

interface Props extends ButtonProps {
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  iconPosition: "left" | "right";
}

const ButtonWithIcon: React.FC<Props> = ({ icon, iconPosition, ...rest }) => {
  const Icon = icon;

  return iconPosition === "left" ? (
    <Button {...rest}>
      <IconWrapper iconPosition={iconPosition}>
        <Icon />
      </IconWrapper>
      {rest.children}
    </Button>
  ) : (
    <Button {...rest}>
      {rest.children}
      <IconWrapper iconPosition={iconPosition}>
        <Icon aria-hidden="true" />
      </IconWrapper>
    </Button>
  );
};

export default ButtonWithIcon;
